<template>
  <footer class="news-footer">
    <div class="news-footer__container">
      <div class="news-footer__content">
        <p class="news-footer__text">
          Hecho con
          <svg class="heart-icon" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
          por
          <a href="/" target="_blank" rel="noopener noreferrer" class="news-footer__link">
            devlusaja
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped>
.news-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #1c2127;
  border-top: 1px solid #2d333b;
  padding: 8px 20px;
  z-index: 300;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.3);
}

.news-footer__container {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 240px; /* Ancho del sidebar */
  transition: padding-left 0.3s ease;
}

.news-footer__content {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
}

.news-footer__text {
  font-size: 13px;
  color: #7d8694;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.heart-icon {
  color: #ef4444;
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  10%, 30% {
    transform: scale(1.1);
  }
  20%, 40% {
    transform: scale(1);
  }
}

.news-footer__link {
  color: #4a9eff;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
}

.news-footer__link:hover {
  color: #7b68ee;
}

.news-footer__link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(135deg, #4a9eff, #7b68ee);
  transition: width 0.3s ease;
}

.news-footer__link:hover::after {
  width: 100%;
}

/* Social Links */
.news-footer__social {
  display: flex;
  align-items: center;
  gap: 10px;
}

.social-link {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #2d333b;
  border-radius: 8px;
  color: #7d8694;
  transition: all 0.2s ease;
  text-decoration: none;
}

.social-link:hover {
  background: rgba(74, 158, 255, 0.1);
  border-color: #4a9eff;
  color: #4a9eff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(74, 158, 255, 0.2);
}

.social-link:active {
  transform: translateY(0);
}

.social-link svg {
  width: 18px;
  height: 18px;
}

/* Responsive */
@media (max-width: 768px) {
  .news-footer {
    padding: 8px 12px;
  }

  .news-footer__container {
    padding-left: 0; /* Sin padding en mobile */
  }

  .news-footer__content {
    gap: 16px;
  }

  .news-footer__text {
    font-size: 13px;
  }

  .social-link {
    width: 32px;
    height: 32px;
  }

  .social-link svg {
    width: 16px;
    height: 16px;
  }
}

@media (max-width: 480px) {
  .news-footer {
    padding: 6px 10px;
  }

  .news-footer__content {
    gap: 12px;
  }

  .news-footer__text {
    font-size: 12px;
  }

  .news-footer__social {
    gap: 8px;
  }

  .social-link {
    width: 30px;
    height: 30px;
  }

  .social-link svg {
    width: 15px;
    height: 15px;
  }
}
</style>
